export enum ENUM_ALL_ROLES {
  // ADMIN ROLES
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',

  // MAIN STORE
  FRONT_DESK = 'FRONT_DESK',
  CS = 'CUSTOMER_SERVICE',
  CS_ADMIN = 'CUSTOMER_SERVICE_ADMIN',
  CS_SUPER_ADMIN = 'CUSTOMER_SERVICE_LEAD',
  CS_OUTBOUND = 'CUSTOMER_SERVICE_OUTBOUND',
  CS_INBOUND = 'CUSTOMER_SERVICE_INBOUND',

  // KITCHEN
  KITCHEN_ADMIN = 'KITCHEN_ADMIN'
}

export enum ENUM_COKITCHEN_TEAM {
  MAIN_STORE = 'main-store',
  KITCHEN = 'kitchen'
}

export enum ENUM_MAIN_STORE_ROLES {
  FRONT_DESK = 'FRONT_DESK',
  CS = 'CUSTOMER_SERVICE',
  CS_ADMIN = 'CUSTOMER_SERVICE_ADMIN',
  CS_SUPER_ADMIN = 'CUSTOMER_SERVICE_LEAD',
  CS_OUTBOUND = 'CUSTOMER_SERVICE_OUTBOUND',
  CS_INBOUND = 'CUSTOMER_SERVICE_INBOUND'
}

export enum ENUM_KITCHEN_ROLES {
  KITCHEN_ADMIN = 'KITCHEN_ADMIN'
}
export enum ENUM_PREP_ROLES {
  KITCHEN_ADMIN = 'PREP_ADMIN',
  includes = 'includes'
}
export type PANEL_ROLES = ENUM_MAIN_STORE_ROLES | ENUM_KITCHEN_ROLES | string;
